/**
 * 시스템 > 장비관리 > 장비 편집 컴포넌트 Store
 *
 * @since 2018-03-12
 * @author devp018
 * @modify jupil.Go <devp018>
 */
import {i18n} from '~/plugins/i18n'
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

/*
  Method - bpsConverter
  Description - bps 단위를 값에 따라 bps, Kbps, Mbps, Gbps, Tbps로 변환.
*/
function bpsConverter (bps, fixed = 1) {
  let i = 1
  const byteUnits = [' bps', ' Kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps']

  while (bps > 1023) {
    bps = bps / 1024
    i++
  }
  return { value: bps.toFixed(bps ? fixed : 0), unit: byteUnits[i], code: i }
}

export const state = () => ({
  // mode type
  interfaceModeOptions: [
    {value: 'L2[BRIDGE]', label: 'L2[BRIDGE]'},
    {value: 'L2[PORT TRUNKING]', label: 'L2[PORT TRUNKING]'},
    {value: 'L3', label: 'L3'},
    {value: 'L3[DHCP]', label: 'L3[DHCP]'},
    {value: 'L3[PPPoE]', label: 'L3[PPPoE]'}
  ],
  devicesUrl: `${apiPrefix}/devices`,
  imgUrl: `${apiPrefix}/devices/img`,
  monGetUrl: `${apiPrefix}/devices-mon-if`,
  monDelUrl: `${apiPrefix}/devices-mon-if-del`,
  monSetUrl: `${apiPrefix}/devices-mon-if-set`,
  bgImage: null,
  delParam: {
    device_mon_if_id_list: ''
  },
  migBodyData: [],
  popupMIData: { // lastet selected monitering interface table's row
    device_id: null,
    device_mon_if_id: null, // monitering interface row's primary id
    device_mon_if_bdwth: null, // 대역폭 기본 단위(KB)
    bdwth_value: 1,
    bdwth_unit: 0,
    device_mon_if_fail_event_yn: 0, // 장애 알람 사용여부 : 1 on / 0 off
    device_mon_if_ip: null, // 주소
    device_mon_if_mac_val: null, // MAC 주소
    device_mon_if_mask_val: null, // IPv4 서브넷 마스크
    device_mon_if_mng_name: null, // 관리번호
    device_mon_if_rsrc_event_yn: 0, // 임계치 알람 사용여부 : 1 on / 0 off
    device_mon_if_uname: null, // inteface name
    device_mon_if_v6_ip: null, // IPv6 주소
    device_mon_if_v6_prefix: 64, // IPv6 Prefix
    // device_mon_if_vpn_yn: 0 // VPN 사용여부 : 1 on / 0 off
    device_mon_if_mode: 'L3' // 모드
  },
  devicesInfo: { // 장비 상세정보 설정
    device_id: null, // NEW???
    parent_device_id: 0, // NEW???
    device_type: 0, // NEW???
    device_create_dt: '', // "2018-09-18 17:20",
    device_seq: 0,
    device_uname: '',
    device_desc: '',
    device_mon_yn: 0,
    device_mon_event_inhrit_yn: 0,
    device_mon_if_auto_update_yn: 0,
    device_mon_node_yn: 0,
    device_ip: '',
    device_mng_type: 1, // 1: config mode, 2: view mode, 3: monitoring node
    device_dir_type: 0,
    device_model_type: 0, // MF2 : 9 , MFI : 10 , MFD : 11, MF2 AE : 12, Black Swan : 20
    device_model_name: '', // 모델명
    device_fan_cnt: 0, // fan 개수
    device_psu_cnt: 0, // psu 개수
    device_api_port: 443, // NEW???
    device_ssh_port: 0, // NEW???
    device_term_start_date: '',
    device_term_end_date: '',
    device_ver_val: '', // 버전
    device_rev_val: '', // 리비전
    device_serial_val: '', // 시리얼
    device_client_val: '', // Client ID
    device_os_val: '',
    device_host_val: '',
    device_mng_val: 0,
    device_running_time: '', // "15:40:40 up 70 days, 20:52, 0 users",
    device_license_start: '',
    device_license_end: '',
    device_mach_id: '' // 장비 ID
  },
  orgDevicesInfo: {}
})

export const mutations = {
  setDevicesInfo (state, items) {
    state.devicesInfo = _.cloneDeep(items)
    state.orgDevicesInfo = _.cloneDeep(items)
  },
  resetPopupMIData (state) { // lastet selected monitering interface table's row
    state.popupMIData.device_id = null
    state.popupMIData.device_mon_if_id = null // monitering interface row's primary id
    state.popupMIData.device_mon_if_bdwth = 1048576 // 대역폭 기본 단위(KB)
    state.popupMIData.bdwth_value = 1
    state.popupMIData.bdwth_unit = 3
    state.popupMIData.device_mon_if_fail_event_yn = 1 // 장애 알람 사용여부 : 1 on / 0 off
    state.popupMIData.device_mon_if_ip = null // 주소
    state.popupMIData.device_mon_if_mac_val = null // MAC 주소
    state.popupMIData.device_mon_if_mask_val = null // IPv4 서브넷 마스크
    state.popupMIData.device_mon_if_mng_name = null // 관리번호
    state.popupMIData.device_mon_if_rsrc_event_yn = 1 // 임계치 알람 사용여부 : 1 on / 0 off
    state.popupMIData.device_mon_if_uname = null // inteface name
    // state.popupMIData.device_mon_if_vpn_yn = 0 // VPN 사용여부 : 1 on / 0 off
    state.popupMIData.device_mon_if_mode = 'L3' // 모드
    state.popupMIData.device_mon_if_v6_ip = null // IPv6 주소
    state.popupMIData.device_mon_if_v6_prefix = 64 // IPv6 Prefix
  },
  setPopupMIData (state, data) { // lastet selected monitering interface table's row
    state.popupMIData.device_id = data.device_id
    state.popupMIData.device_mon_if_id = data.device_mon_if_id
    state.popupMIData.device_mon_if_bdwth = data.device_mon_if_bdwth
    state.popupMIData.bdwth_value = data.deviceMonIfBdwth.value
    state.popupMIData.bdwth_unit = data.deviceMonIfBdwth.code
    state.popupMIData.device_mon_if_fail_event_yn = data.device_mon_if_fail_event_yn
    state.popupMIData.device_mon_if_mng_name = data.device_mon_if_mng_name
    state.popupMIData.device_mon_if_rsrc_event_yn = data.device_mon_if_rsrc_event_yn
    state.popupMIData.device_mon_if_uname = data.device_mon_if_uname
    state.popupMIData.device_mon_if_ip = data.device_mon_if_ip
    state.popupMIData.device_mon_if_mask_val = data.device_mon_if_mask_val
    state.popupMIData.device_mon_if_v6_ip = data.device_mon_if_v6_ip
    state.popupMIData.device_mon_if_v6_prefix = data.device_mon_if_v6_prefix
    state.popupMIData.device_mon_if_mac_val = data.device_mon_if_mac_val
    // state.popupMIData.device_mon_if_vpn_yn = data.device_mon_if_vpn_yn
    state.popupMIData.device_mon_if_mode = data.device_mon_if_mode
  },
  setMonData (state, data) {
    state.migBodyData = []
    state.migBodyData = data.map(items => {
      items.deviceMonIfBdwth = bpsConverter(items.device_mon_if_bdwth, 0)
      return items
    })
  },
  delMonData (state, data) {
    for (const itemIndex of data) {
      state.migBodyData.splice(itemIndex, 1)
    }
  }
}
export const actions = {
  async getDevicesInfo ({commit, state}, id) {
    const res = await this.$axios.$get(`${state.devicesUrl}/${id}`)
    if (res.code === 'ok') {
      commit('setDevicesInfo', res.result[0])
    }
    return res
  },
  // 미사용 코드로 보임 (2020-04-06)
  // async getImg ({commit, state}) {
  //   const {code, result} = await this.$axios.$get(`${state.imgUrl}/${state.devicesInfo.device_id}`)
  //   if (code === 'ok') {
  //     state.bgImage = result
  //     return true
  //   }
  //   state.bgImage = `${state.imgUrl}/${state.devicesInfo.device_id}`
  //   return false
  // },
  // async setBgImg ({commit, state}) {
  //   const {code, result} = await this.$axios.$put(`${state.imgUrl}/${state.devicesInfo.device_id}`)
  //   if (code === 'ok') {
  //     state.bgImage = result
  //     return true
  //   }
  //   state.bgImage = `${state.imgUrl}/${state.devicesInfo.device_id}`
  //   return false
  // },
  async delBgImg ({commit, state}) {
    const res = await this.$axios.$delete(`${state.imgUrl}/${state.devicesInfo.device_id}`)
    return res
  },
  async editItems ({commit, state}, param) {
    const res = await this.$axios.$put(`${state.devicesUrl}/update/${state.devicesInfo.device_id}`, param, {loading: true})
    return res
  },
  async updateMonNodeInfo ({commit, state}, param) {
    const res = await this.$axios.$put(`${state.devicesUrl}/mon-node`, param)
    return res
  },
  async addMonItems ({commit, state}, param) {
    const res = await this.$axios.$post(`${state.monSetUrl}/${state.devicesInfo.device_id}`, param)
    return res
  },
  async edtMonItems ({commit, state}, param) {
    const res = await this.$axios.$put(`${state.monSetUrl}/${state.devicesInfo.device_id}`, param)
    return res
  },
  async delMonItems ({commit, state}, param) {
    const res = await this.$axios.$put(state.monDelUrl, param.list, {alertMsg: i18n.t('msg.removeApply')})
    if (res.code === 'ok') {
      commit('delMonData', param.index)
    }
    return res
  },
  async setMonInhrit ({commit, dispatch, state}) {
    const res = await this.$axios.$put(`${state.devicesUrl}/mon-inhrit/${state.devicesInfo.device_id}/${state.devicesInfo.device_mon_event_inhrit_yn}`, null, {loading: false, successAlert: false})
    if (res.code === 'ok') {
      return dispatch('getDevicesInfo', state.devicesInfo.device_id)
    }
    return res
  },
  // 모니터링 인터페이스 업데이트 실행
  async processMI ({commit, state}, {name, data}) {
    const res = await this.$axios.$put(`/api/sm/devices/if/${name}/${state.devicesInfo.device_id}`, data, {loading: false, successAlert: false})
    return res
  },
  async getMoniteringList ({commit, state}, param) {
    const res = await this.$axios.$post(`${state.monGetUrl}/${param.device_id}`, param.data, {loading: false, successAlert: false})
    if (res.code === 'ok') {
      commit('setMonData', res.result)
    }
    return res
  }
}

export const getters = {
}

export const strict = false
